import { ActionLog } from "./ActionLog"
import { LOG_ACTION } from "./actionLogActionTypes"



export type ActionLogStore = {
    logs: ActionLog[]
}

const defaultState: ActionLogStore = {
    logs: [],
}

const FIVE_MINUTES = 1000 * 60 * 5
function recentLogs(actionLog: ActionLog) {
    return (Date.now() - actionLog.time) < FIVE_MINUTES
}

function newState(state): ActionLogStore {
    const cleanState = {logs: []}
    cleanState.logs = state.logs.filter(recentLogs)
    return cleanState
}

function actionLogReducer(state = defaultState, action) {
    const cleanState = newState(state)
    switch(action.type) {
    case LOG_ACTION:
        cleanState.logs.unshift(action.payload)
        return cleanState
    default:
        return state
    }
}


export default actionLogReducer


// WEBPACK FOOTER //
// ./src/state/actionlog/actionLogReducer.ts